export const getBase64Img = (base64: string) => {
  return `data:image/jpg;base64,${base64}`;
};
